export default __webpack_public_path__ + "static/media/Mic_alt_duotone.5a31ac5f.svg";